module.exports = __webpack_public_path__ + "static/media/nextPage.cf9a7ef1.svg";